export default __webpack_public_path__ + "static/media/DolphinTank_Logo_(5).a5d2f0e7.png";